import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CategoriasService } from 'src/app/services/categorias.service';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html',
  styleUrls: ['./categories-list.component.scss']
})
export class CategoriesListComponent implements OnInit {

  categorias: Observable<any[]>;
  listCategories: any[] = [];

  titleDialog = 'Selecciona una o más categorías';
  loading: boolean = true;

  constructor(private categoriasService: CategoriasService, private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<CategoriesListComponent>) { }

  ngOnInit(): void {
    this.categoriasService.getAllCategories().subscribe({
      next: (data) => {
        this.categorias = data.data.data;
        this.loading = false;
      }
    })
    const preselected = this.data?.categorySelect;
    if (preselected) {
      this.listCategories = Array.isArray(preselected) ? [...preselected] : [preselected];
    }
  }

  isSelected(categoria: any): boolean {
    return this.listCategories.some(c => c.id === categoria.id);
  }

  selectCategory(categoria: any) {
    const index = this.listCategories.findIndex(c => c.id === categoria.id);
    if (index > -1) {
      this.listCategories.splice(index, 1);
    } else {
      this.listCategories.push(categoria);
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  saveCategory() {
    if (!this.listCategories.length) return;
    this.dialogRef.close(this.listCategories);
  }

}
